import COLORS from './colors'

export const shotQualityLevels = {
  0: { label: 'Poor', color: COLORS['Quality_scale-Poor'] },
  1: { label: 'Fair', color: COLORS['Quality_scale-Fair'] },
  2: { label: 'Average', color: COLORS['Quality_scale-Average'] },
  3: { label: 'Good', color: COLORS['Quality_scale-Good'] },
  4: { label: 'Excellent', color: COLORS['Quality_scale-Excellent'] }
}
